<template lang="pug">
  .widget-donut
    AppChartDonutDouble(
      :circles="[{ value, tooltip }]"
      :thickness="thickness"
      :size="size"
    )
</template>

<script>
export default {
  name: 'InsightsUtilizationWidgetSingleDonut',
  components: {
    AppChartDonutDouble: () => import('~/components/AppChartDonutDouble.vue'),
  },
  props: {
    value: { type: Number, required: true },
    tooltip: { type: String, default: '' },
    thickness: { type: Number, default: 20 },
    size: { type: Number, default: 132 },
  },
};
</script>
